export default "__VITE_ASSET__C1ToypS6__"